module.exports = __webpack_public_path__ + "img/frame (10).5ad1300d.jpg";